import React, { useEffect, useState } from "react";
import PageHeading from "../../components/PageHeading";
import { useQuery } from "react-query";
import providerServices from "../../services/ApiProviders";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import { Navigate } from "react-router-dom";
import Select from "../../components/Select";
import { formattedProviders } from "../../utils/functions";
import { toast } from "react-hot-toast";

const AutoProductList = ({ title }) => {
    const [provider, setProvider] = useState("");
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const { data, isLoading, error } = useQuery("getAllProviders", () =>
        providerServices.getAllProviders()
    );

    useEffect(() => {
        const getAllProducts = () => {
            setLoading(true);
            providerServices
                .getAllProvidersProducts(provider)
                .then(res => {
                    if (res.data.data?.length > 0) {
                        setProducts(res.data.data);
                    } else if (res.data?.data?.products.length > 0) {
                        setProducts(res.data.data.products);
                    } else {
                        setProducts([]);
                        toast.error("لا يدعم هذا الموقع عرض المنتجات");
                    }

                    setLoading(false);
                })
                .catch(err => {
                    toast.error("لا يدعم هذا الموقع عرض المنتجات");
                    setLoading(false);
                    setProducts([]);
                });
        };
        console.log(provider);
        if (provider !== "" && provider !== 0) {
            getAllProducts();
        } else {
            setProducts([]);
        }
    }, [provider]);

    if (error) {
        return <Navigate to="/404" />;
    }

    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard className={isLoading ? "min-h-[400px] relative" : ""}>
                {isLoading ? (
                    <DSpinner />
                ) : (
                    <div className={loading ? "min-h-[400px] relative" : ""}>
                        <label>
                            عرض منتجات:
                            <Select
                                options={formattedProviders(data.data)}
                                value={provider}
                                changeHandler={setProvider}
                            />
                        </label>
                        {loading ? (
                            <DSpinner />
                        ) : (
                            products.length > 0 && (
                                <div className="mt-4 text-left">
                                    {products.map(p => (
                                        <div>{JSON.stringify(p)}</div>
                                    ))}
                                </div>
                            )
                        )}
                    </div>
                )}
            </DCard>
        </div>
    );
};

export default AutoProductList;
